import { switchTree } from '@fs/zion-tree-groups'
import { useEffect } from 'react'

export default function useSwitchTree({
  focusPerson,
  selectTree,
  currentTreeId,
  isResearcherGroup,
}: Omit<Parameters<typeof switchTree>[0], 'onHasLoaded'>): void {
  useEffect(() => {
    switchTree({ focusPerson, selectTree, currentTreeId, isResearcherGroup })
  }, [currentTreeId, focusPerson, selectTree, isResearcherGroup])
}
